import React from "react";
import { Card, Button } from "@nextui-org/react";
import { motion } from "framer-motion";

const MotionButton = motion(Button);
const btnAnim = { whileTap: { scale: 0.98 } };

const AltEntriesFloatingBar = ({
  clearableCount = 0,
  clearing,
  onOpenModal,
}) => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 16,
        left: 0,
        right: 0,
        zIndex: 999,
        display: "flex",
        justifyContent: "center",
        padding: "0 16px",
        pointerEvents: "none",
      }}
    >
      <Card
        variant="bordered"
        className="cardShadow"
        css={{
          mw: "550px",
          w: "100%",
          bg: "rgba(255, 255, 255, 0.94)",
          backdropFilter: "blur(12px)",
          borderRadius: "16px",
          pointerEvents: "auto",
          borderColor: "$border",
        }}
      >
        <Card.Body
          css={{
            py: "10px",
            px: "16px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <MotionButton
            auto
            size="md"
            color="error"
            css={{ width: "100%", borderRadius: "10px", fontWeight: 600 }}
            disabled={clearableCount === 0 || clearing}
            onClick={onOpenModal}
            {...btnAnim}
          >
            {clearableCount > 0
              ? `Clear Selected (${clearableCount})`
              : "No Entries to Clear"}
          </MotionButton>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AltEntriesFloatingBar;
